"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementStatsValue = void 0;
function incrementStatsValue(state, opts, key) {
    state.stats[key] = state.stats[key] + 1;
    opts.statsFn(Object.assign({}, state.stats));
}
exports.incrementStatsValue = incrementStatsValue;
//# sourceMappingURL=increment-stats-value.js.map